import script from "./ReviewEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewEmail.vue?vue&type=script&setup=true&lang=js"

import "./ReviewEmail.vue?vue&type=style&index=0&id=54469460&lang=scss"

const __exports__ = script;

export default __exports__